"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _InventoryDestination_1 = require("./_InventoryDestination");
var _InventoryFilter_1 = require("./_InventoryFilter");
var _InventoryOptionalFields_1 = require("./_InventoryOptionalFields");
var _InventorySchedule_1 = require("./_InventorySchedule");
exports._InventoryConfiguration = {
    type: "structure",
    required: [
        "Destination",
        "IsEnabled",
        "Id",
        "IncludedObjectVersions",
        "Schedule"
    ],
    members: {
        Destination: {
            shape: _InventoryDestination_1._InventoryDestination
        },
        IsEnabled: {
            shape: {
                type: "boolean"
            }
        },
        Filter: {
            shape: _InventoryFilter_1._InventoryFilter
        },
        Id: {
            shape: {
                type: "string"
            }
        },
        IncludedObjectVersions: {
            shape: {
                type: "string"
            }
        },
        OptionalFields: {
            shape: _InventoryOptionalFields_1._InventoryOptionalFields
        },
        Schedule: {
            shape: _InventorySchedule_1._InventorySchedule
        }
    }
};
//# sourceMappingURL=_InventoryConfiguration.js.map